import React from "react";
import {
  Datagrid,
  TextField,
  ArrayField,
  Labeled,
  ReferenceField,
  DateField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  useTranslate,
} from "react-admin";
import { Box, Card, CardContent } from "@mui/material";

import { UnitPriceField } from "./unit_price_field";
import { commonStyles } from "../common_styles";

export const DetailsByProducerExpand = (props: any) => {
  const { record, certifications } = props;
  if (record === undefined) {
    return null;
  }

  const farmingCertificationIds = record["farming_certification_ids"];
  const CertificationFieldProps = {
    certifications,
    farmingCertificationIds,
  };

  return (
    <Card>
      <CardContent style={{ display: "flex", flexDirection: "column" }}>
        <FarmingCertificationField {...CertificationFieldProps} />
        <OfferRequestArrayField {...props} source="offer_requests" />
      </CardContent>
    </Card>
  );
};

type FarmingCertificationFieldProps = {
  certifications: any;
  farmingCertificationIds: number[];
};

export const FarmingCertificationField = (props: FarmingCertificationFieldProps) => {
  const { certifications, farmingCertificationIds } = props;

  const farmingRecords = {
    farming_certifications: farmingCertificationIds.map((id: number) =>
      certifications.find((certification: any) => certification.id === id)
    ),
  };

  return (
    <Labeled label="resources.producer_summaries.fields.farming_certification_ids">
      <ArrayField source="farming_certifications" record={farmingRecords}>
        <SingleFieldList linkType={false}>
          <ChipField source="label" />
        </SingleFieldList>
      </ArrayField>
    </Labeled>
  );
};

export const OfferRequestArrayField = (props: any) => {
  const { record, isExistRegion } = props;
  const translate = useTranslate();
  if (record === undefined) {
    return null;
  }

  return (
    <Labeled {...props} label="resources.producer_summaries.fields.offer_requests">
      <ArrayField {...props} source="offer_requests">
        <Box sx={commonStyles.showPageInnerDatagrid}>
          <Datagrid bulkActionButtons={false} empty={null}>
            <DateField source="updated_at" locales={"ja"} sortable={false} />
            <ReferenceField
              reference="annums"
              source="annum_id"
              link={false}
              sortable={false}
              emptyText={translate("ui.value.not_set")}
            >
              <TextField source="name" sortable={false} />
            </ReferenceField>
            {isExistRegion && (
              <ReferenceField reference="regions" source="region_id" link={false} sortable={false}>
                <TextField source="name" sortable={false} />
              </ReferenceField>
            )}
            <ReferenceField reference="brands" source="brand_id" link={false} sortable={false}>
              <TextField source="name" sortable={false} />
            </ReferenceField>
            <ReferenceField reference="grades" source="grade_id" link={false} sortable={false}>
              <TextField source="name" sortable={false} />
            </ReferenceField>
            <UnitPriceField source="unit_price" sortable={false} />
            <ReferenceArrayField reference="special_conditions" source="special_condition_ids" sortable={false}>
              <SingleFieldList linkType={false}>
                <ChipField source="display_text" />
              </SingleFieldList>
            </ReferenceArrayField>
          </Datagrid>
        </Box>
      </ArrayField>
    </Labeled>
  );
};
